import Vue from 'vue'
import Router from 'vue-router'


const gini = () => import('@/components/website/')
const home = () => import('@/components/website/home/home')
const doctor_page = () => import('@/components/website/doctor/doctor_page')
const pcos_program = () => import('@/components/website/program/pcos_program')
const blood_pressure = () => import('@/components/website/program/blood_pressure')
const diabetes_program = () => import('@/components/website/program/diabetes_program')
const diabetes_form = () => import('@/components/website/program/diabetes_form')
const high_cholesterol = () => import('@/components/website/program/high_cholesterol')
const fatty_liver_programme = () => import('@/components/website/program/fatty_liver_programme')
const primary_care = () => import('@/components/website/program/primary_care')
const thyroid_program = () => import('@/components/website/program/thyroid_program')
const about_us = () => import('@/components/website/about/about_us')
const gini_app = () => import('@/components/website/app/gini_app')
const blog = () => import('@/components/website/blog/blog')
const blog_details = () => import('@/components/website/blog/blog-details')
const how_it_works = () => import('@/components/website/how-it-works/how_it_works')
const privacy_policy = () => import('@/components/website/privacy-policy/privacy_policy')
const refund_policy = () => import('@/components/website/privacy-policy/refund_policy')
const terms_and_conditions = () => import('@/components/website/privacy-policy/terms_and_conditions')
const landing_page = () => import('@/components/website/landing-page/landing_page')

const step1 = () => import('@/components/website/register/step1')
const step2 = () => import('@/components/website/register/step2')
const step3 = () => import('@/components/website/register/step3')
const step4 = () => import('@/components/website/register/step4')
const step5 = () => import('@/components/website/register/step5')
const step_1 = () => import('@/components/website/landing-page/steps/step_1')
const findProgram = () => import('@/components/website/landing-page/steps/index')
const request_a_call = () => import('@/components/website/register/request-a-call')
const contact_us = () => import('@/components/website/contact/contact_us')
const NotFound = () => import('@/components/website/shared/notFound404.vue')

const Payment = () => import('@/components/website/payment/payment-form')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      component: gini,
      children: [
        // { path: '/', name: 'home.home', component: home, meta: { permission: '' } },
        { path: '/doctor', name: 'doctor.doctor_page', component: doctor_page },
        { path: '/pcos-program', name: 'program.pcos_program', component: pcos_program },
        { path: '/blood-pressure', name: 'program.blood_pressure', component: blood_pressure },
        { path: '/diabetes-program', name: 'program.diabetes_program', component: diabetes_program },
        { path: '/diabetes-form', name: 'program.diabetes_form', component: diabetes_form },
        { path: '/high-cholesterol', name: 'program.high_cholesterol', component: high_cholesterol },
        { path: '/fatty-liver-programme', name: 'program.fatty_liver_programme', component: fatty_liver_programme },
        { path: '/primary-care', name: 'program.primary_care', component: primary_care },
        { path: '/thyroid_program', name: 'program.thyroid_program', component: thyroid_program },
        { path: '/about-us', name: 'about.about_us', component: about_us },
        { path: '/gini-app', name: 'app.gini_app', component: gini_app },
        { path: '/blog', name: 'blog.blog', component: blog },
        { path: '/blog-details', name: 'blog.blog_details', component: blog_details },
        { path: '/how-it-works', name: 'how-it-works.how_it_works', component: how_it_works },
        { path: '/privacy-policy', name: 'privacy-policy.privacy_policy', component: privacy_policy },
        { path: '/refund-policy', name: 'privacy-policy.refund_policy', component: refund_policy },
        { path: '/terms-and-conditions', name: 'privacy-policy.terms_and_conditions', component: terms_and_conditions },
        { path: '/', name: 'landing-page.landing_page', component: landing_page },

        { path: '/payment', name: 'payment.Payment', component: Payment },

        { path: '/book-an-appointment', name: 'register.step1', component: step1 },
        { path: '/step2', name: 'register.step2', component: step2 },
        { path: '/step3', name: 'register.step3', component: step3 },
        { path: '/step4', name: 'register.step4', component: step4 },
        { path: '/step5', name: 'register.step5', component: step5 },
        { path: '/find-my-program', name: 'landing.findProgram', component: findProgram },
        { path: '/request-a-call', name: 'register.request_a_call', component: request_a_call },
        { path: '/contact-us', name: 'contact.contact_us', component: contact_us },
        { path: '*', name: 'Not Found', component: NotFound }
      ]
    }
  ]
});


// WEBPACK FOOTER //
// ./src/router/index.js